import * as React from 'react';

import './index.scss';

export const Loading: React.SFC = () => {
    return (
        <div id="loading-wrapper">
            <div className="loading-holder">
                <svg id="loading" data-name="Component 3 – 1" xmlns="http://www.w3.org/2000/svg" width="60" viewBox="0 0 38.708 38.708">
                    <g id="Group_157" data-name="Group 157" transform="translate(7.358 12.586)">
                        <path id="Path_478" data-name="Path 478" d="M347.57,471.579,343.607,474a12.219,12.219,0,0,1-20.16,12.894l-3.26,3.26a16.805,16.805,0,0,0,27.384-18.577Z" transform="translate(-320.186 -471.579)" fill="#231f20" />
                    </g>
                    <g id="Group_158" data-name="Group 158" transform="translate(2.507 2.507)">
                        <path id="Path_479" data-name="Path 479" d="M327.413,451.589a16.866,16.866,0,0,0-16.848,16.847,16.664,16.664,0,0,0,1.46,6.767l3.964-2.423a12.219,12.219,0,0,1,20.16-12.894l3.26-3.26A16.789,16.789,0,0,0,327.413,451.589Z" transform="translate(-310.565 -451.589)" fill="#231f20" />
                    </g>
                    <g id="Group_161" data-name="Group 161">
                        <g id="Group_159" data-name="Group 159" transform="translate(0 18.555)">
                            <rect id="Rectangle_34" data-name="Rectangle 34" width="23.627" height="4.874" transform="translate(0 16.707) rotate(-45)" fill="#231f20" />
                        </g>
                        <g id="Group_160" data-name="Group 160" transform="translate(18.544 0)">
                            <rect id="Rectangle_35" data-name="Rectangle 35" width="23.643" height="4.874" transform="translate(0 16.718) rotate(-44.999)" fill="#ec1c24" />
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    );
};
